import React from 'react';
import { Card, Container, Table } from 'react-bootstrap';

const ApiPartnerTopUpHistory = () => {
  const history = [
    { reference: 'TPU-4829', date: '28 Oct 2025', amount: '₹5,00,000', status: 'Allocated', remarks: 'IMPS settled · Ref IMPS208542' },
    { reference: 'TPU-4512', date: '16 Sep 2025', amount: '₹3,50,000', status: 'In Review', remarks: 'Awaiting compliance clearance' },
    { reference: 'TPU-4304', date: '05 Aug 2025', amount: '₹2,00,000', status: 'Allocated', remarks: 'NEFT settled · Ref NEFT720194' }
  ];

  return (
    <div className="api-partner-topup-history">
      <Container fluid className="py-4">
        <div className="mb-4">
          <div className="text-muted small mb-2">
            <span>Home</span>
            <span className="mx-2">/</span>
            <span>API Partner</span>
            <span className="mx-2">/</span>
            <span>Top Up History</span>
          </div>
          <h1 className="mb-2">Top-up Request Timeline</h1>
          <p className="text-muted mb-0">
            Browse historic requests, allocation status and settlement references for your float requirements.
          </p>
        </div>

        <Card>
          <Card.Header className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Recent Requests</h5>
            <div className="d-flex gap-2">
              <button type="button" className="btn btn-outline-secondary btn-sm">
                <i className="bi bi-calendar-week me-1"></i>
                Period
              </button>
              <button type="button" className="btn btn-primary btn-sm">
                <i className="bi bi-download me-1"></i>
                Export PDF
              </button>
            </div>
          </Card.Header>
          <Card.Body className="p-0">
            <Table responsive hover className="mb-0 align-middle">
              <thead>
                <tr>
                  <th>Reference</th>
                  <th>Date</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Remarks</th>
                </tr>
              </thead>
              <tbody>
                {history.map((item) => (
                  <tr key={item.reference}>
                    <td className="fw-semibold">{item.reference}</td>
                    <td>{item.date}</td>
                    <td>{item.amount}</td>
                    <td>
                      <span
                        className={`badge rounded-pill ${
                          item.status === 'Allocated' ? 'bg-success-subtle text-success' : 'bg-warning-subtle text-warning'
                        }`}
                      >
                        {item.status}
                      </span>
                    </td>
                    <td>{item.remarks}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default ApiPartnerTopUpHistory;


